import React from 'react'
import { Space } from '../../layouts'
import { P } from '../StyledText'
import { messages } from '../../config/messages'

export const DisabledUploadHint = ({
  packFormDirty,
}: {
  packFormDirty: boolean
}) =>
  packFormDirty ? (
    <Space mb={4}>
      <P color="error">{messages.unsavedDataOnPackForm}</P>
    </Space>
  ) : null
